var docShape, docTypes, documentId, initial, miniDsShape, number, object, optional, shape, string, _ref;

documentId = require('lib/db_docs/field_types/document_id');

docShape = require('lib/db_docs/field_types/doc_shape');

docTypes = require('lib/db_docs/doc_types');

initial = require('lib/db_docs/field_types/type_decorators').initial;

shape = require('lib/db_docs/field_types/shape');

_ref = require('lib/db_docs/field_types/built_in_types'), string = _ref.string, number = _ref.number, object = _ref.object;

optional = shape.typeDecorators.optional;

miniDsShape = docShape({
  docType: initial(docTypes.MINI_DOCUMENT_DOC)(string),
  lastUpdateDate: optional(number),
  lastUpdateProjectName: optional(string),
  name: initial('')(string),
  orderNumber: optional(number),
  slug: optional(string),
  docRootId: optional(documentId),
  template: initial('initial')(string),
  options: optional(object)
});

module.exports = miniDsShape;
